import { usePostEmailVerificationEmail } from 'api/modules/accounts'
import cx from 'classnames'
import { FormattedMessage, useIntl } from 'locales/index'
import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import HeadlessLayout from 'shared/components/layout/HeadlessLayout'
import { Button, GoToButton, Typography } from '@commutifi-fe/ui'
import { useNotifications } from '@commutifi-fe/commutifi-specific/hooks'
import { PublicRouting } from 'src/routing'
import styles from './styles.module.scss'

function RegistrationSuccess({ history, location }: RouteComponentProps<any, any, { id?: string; email?: string }>) {
  const intl = useIntl()
  const commutifiNotification = useNotifications()

  const handleGoToAuth = () => history.push(PublicRouting.auth.path)
  const { isPending: isLoading, mutateAsync: sendEmail } = usePostEmailVerificationEmail()
  const handleResendEmail = async () => {
    try {
      await sendEmail({ accountId: location.state?.id, email: location.state?.email })
      commutifiNotification.success(intl.formatMessage({ id: 'registration.emailVerification.send.success' }))
    } catch (error) {
      commutifiNotification.error({
        description: intl.formatMessage({ id: 'registration.errors.emailVerification.resend' })
      })
    }
  }

  return (
    <HeadlessLayout className={cx('u-flex-column u-flex-align-center', styles['registration-success-content'])}>
      <Typography.Title styleguide="marketing">
        <FormattedMessage id="registration.success.title" />
      </Typography.Title>
      <Typography.Text styleguide="marketing" type="secondary">
        <FormattedMessage id="registration.success.description" />
      </Typography.Text>
      <div className="u-margin-vertical--large-2 u-flex-space-between u-flex-wrap">
        <Typography.Text styleguide="marketing">
          <FormattedMessage id="registration.failedEmail" />

          <Button type="link" loading={isLoading} style={{ padding: 0 }} onClick={handleResendEmail}>
            <Typography.Text styleguide="marketing" strong="semi-bold" underline className="u-margin-left--small">
              <FormattedMessage id="global.resend" />
            </Typography.Text>
          </Button>
        </Typography.Text>
        <GoToButton size="middle" onClick={handleGoToAuth}>
          <FormattedMessage id="global.goToLogin" />
        </GoToButton>
      </div>
    </HeadlessLayout>
  )
}

export default RegistrationSuccess
